import { useEffect } from 'react';
import { Outlet, useNavigate, useMatch } from 'react-router-dom';
import { IconLoader, PermissionDenied, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';

import ROUTES from '../../routes';

import cn from './notifications.module.css';

const Notifications = (): React.JSX.Element => {
  const navigate = useNavigate();

  const match = useMatch(ROUTES.NOTIFICATIONS);

  const { activePermissions } = useAppSelector(
    (state) => state.notificaticationCenterDictionaries,
  );

  useEffect(() => {
    if (
      activePermissions?.includes(PermissionEnum.SECTION_NOTIFICATIONS) &&
      match
    ) {
      navigate(ROUTES.NOTIFICATIONS_CENTER);
    }
  }, [match, activePermissions]);

  useEffect(() => {
    let title = 'Notifications';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.notificationsLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (!activePermissions.includes(PermissionEnum.SECTION_NOTIFICATIONS)) {
      content = <PermissionDenied />;
    } else {
      content = <Outlet />;
    }
  }

  return content;
};

export default Notifications;
